import { Table } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Paginator from '../pagination/Paginator'
import Loader from '../loaders/Loader'

export default function  TicketsTable({
        tickets,
        loadingTickets,
        page,
        onPageChange,
        activeTab,
        currentTab,
        titleEmpty,
        handleTicketClick,
        handleImageClick,
        renderStars,
        getStageClass,
        totalPages,
        search,
        setSearch,
        submittedSearch,
        setSubmittedSearch,
        sortField,
        sortOrder,
        setSortField,
        setSortOrder
    })
    {
    const { t } = useTranslation()
    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(prev =>
                prev === 'asc'
                    ? 'desc'
                    : 'asc'
            )
        } else {
            setSortField(field)
            setSortOrder('asc')
        }
    }
	return (
		<>
            <div className="d-flex gap-2 mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder={t("global.search")}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            setSubmittedSearch(search)
                        }
                    }}
                />
                <button
                    className="btn btn-dark"
                    onClick={() => setSubmittedSearch(search)}
                >
                    <i className="fas fa-search"></i>
                </button>
            </div>
			<Table responsive hover className="align-middle">
				<thead>
					<tr>
						<th
                            onClick={() => handleSort('id')}
                            style={{ cursor: 'pointer' }}
                        >
                            #
                            {sortField === 'id' && (
                                sortOrder === 'asc'
                                    ? <i className="fa-solid fa-sort-up ms-2"></i>
                                    : <i className="fa-solid fa-sort-down ms-2"></i>
                            )}
                        </th>
						<th
                            onClick={() => handleSort('name')}
                            style={{ cursor: 'pointer' }}
                        >
                            {t("ticketsTranslate.subject")}
                            {sortField === 'name' && (
                                sortOrder === 'asc'
                                    ? <i className="fa-solid fa-sort-up ms-2"></i>
                                    : <i className="fa-solid fa-sort-down ms-2"></i>
                            )}
                        </th>
						<th>{t("ticketsTranslate.priority")}</th>
						<th>{t("ticketsTranslate.stageLabel")}</th>
						<th
                            onClick={() => handleSort('create_date')}
                            style={{ cursor: 'pointer' }}
                        >
                            {t("ticketsTranslate.createdAt")}

                            {sortField === 'create_date' && (
                                sortOrder === 'asc'
                                    ? <i className="fa-solid fa-sort-up ms-2 pt-2"></i>
                                    : <i className="fa-solid fa-sort-down ms-2 pb-2"></i>
                            )}
                        </th>
						<th></th>
					</tr>
				</thead>

				<tbody>
                    {loadingTickets ? (
                        <tr>
                            <td colSpan={6} className="text-center py-4">
                               <Loader />
                            </td>
                        </tr>
                    ) : (
                        <>
                            {tickets?.length === 0 && (
                                <tr>
                                    <td colSpan={6} className="text-center text-muted py-4">
                                        {titleEmpty}
                                    </td>
                                </tr>
                            )}

                            {tickets?.map(ticket => (
                                <tr
                                    key={ticket.id}
                                    onClick={() => handleTicketClick(ticket)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td className="text-muted">#{ticket.id}</td>

                                    <td>{ticket.name}</td>

                                    <td>{renderStars(ticket.priority)}</td>

                                    <td>
                                        <span className={`badge ${getStageClass(ticket.stage_id?.[0])}`}>
                                            {t(`ticketsTranslate.stage.${ticket.stage_id?.[1]}`)}
                                        </span>
                                    </td>

                                    <td>
                                        <small className="text-muted">
                                            {new Date(ticket.create_date).toLocaleString('es-ES', {
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}
                                        </small>
                                    </td>

                                    <td className="text-end">
                                        <img
                                            src="/images/link-external.svg"
                                            alt="link outlook"
                                            onClick={(e) => handleImageClick(e, ticket)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </>
                    )}
				</tbody>
			</Table>

			{activeTab === currentTab && (
				<Paginator
					page={page}
					totalPages={totalPages}
					onChange={onPageChange}
				/>
			)}
		</>
	)
}